{
  "name": "@mv_rpp/reza-ais-fe",
  "version": "1.7.1-8-SNAPSHOT",
  "license": "MIT",
  "scripts": {
    "start": "npx nx serve reza-ais-fe",
    "build": "npx nx build reza-ais-fe --configuration=production",
    "build.dev": "npx nx build reza-ais-fe -c dev",
    "build.prod": "npx nx build reza-ais-fe",
    "build.test": "npx nx build reza-ais-fe",
    "api": "json-server apps/reza-ais-fe/src/mock-backend/db.json",
    "decode-be-json": "node libs/reza-ais-fe/generated/source/decode-url.js http://rpp-dev-vm1.assecosk.local:32700/reza-ais-be/rest/v3/api-docs libs/reza-ais-fe/generated/source/api-be-decode.json",
    "generate-api-be": "npm run decode-be-json && npm run clean-api-be-output && openapi-generator-cli generate -i ./libs/reza-ais-fe/generated/source/api-be-decode.json -g typescript-angular -o ./libs/reza-ais-fe/generated/be-service/src --template-dir ./libs/reza-ais-fe/generated/source/templates/typescript-angular --additional-properties=ngVersion=17.3.0,fileNaming=kebab-case,npmName=reza-ng-api-be,supportsES6=true,npmVersion=10.5.2,providedIn=none,useSingleRequestParameter=true,stringEnums=true,withInterfaces=true,basePath=/api --global-property=skipFormModel=false",
    "decode-be-json2": "node libs/reza-ais-fe/generated/source/decode-file.js libs/reza-ais-fe/generated/source/swagger-test.json libs/reza-ais-fe/generated/source/api-be-decode2.json",
    "generate-api-be2": "npm run decode-be-json2 && openapi-generator-cli generate -i ./libs/reza-ais-fe/generated/source/api-be-decode2.json -g typescript-angular -o ./libs/reza-ais-fe/generated/be-service/src --additional-properties=ngVersion=17.3.0,fileNaming=kebab-case,npmName=reza-ng-api-be,supportsES6=true,npmVersion=10.5.2,providedIn=none,useSingleRequestParameter=true,stringEnums=true,withInterfaces=true,basePath=/api --global-property=skipFormModel=false",
    "clean-api-be-output": "rimraf ./libs/reza-ais-fe/generated/be-service/src",
    "make-it-pretty": "prettier --write \"./**/*.{ts,scss,html}\"",
    "cypress": "npx nx e2e reza-ais-fe-e2e --watch",
    "cypress.headless": "npx nx e2e reza-ais-fe-e2e",
    "generate-sbom": "cyclonedx-npm --output-file reza_fe_sbom.json --ignore-npm-errors package.json"
  },
  "private": false,
  "files": [
    "dist/apps/reza-ais-fe/browser"
  ],
  "dependencies": {
    "@angular/animations": "18.2.1",
    "@angular/common": "18.2.1",
    "@angular/compiler": "18.2.1",
    "@angular/core": "18.2.1",
    "@angular/forms": "18.2.1",
    "@angular/platform-browser": "18.2.1",
    "@angular/platform-browser-dynamic": "18.2.1",
    "@angular/router": "18.2.1",
    "@ng-web-apis/common": "^3.0.2",
    "@ngneat/cashew": "3.0.0",
    "@ngneat/dialog": "2.1.0",
    "@ngneat/falso": "7.0.1",
    "@ngneat/until-destroy": "10.0.0",
    "@nx/angular": "19.6.2",
    "date-fns": "^4.1.0",
    "echarts": "^5.5.1",
    "json-server": "1.0.0-beta.0",
    "lodash-es": "^4.17.21",
    "minimatch": "^9.0.4",
    "ngx-echarts": "^18.0.0",
    "normalize.css": "^8.0.1",
    "primeflex": "^3.3.1",
    "primeicons": "7.0.0",
    "primeng": "^17.18.15",
    "quill": "^2.0.2",
    "rxjs": "~7.8.0",
    "truncate-html": "^1.1.2",
    "tslib": "^2.3.0",
    "uuid": "^9.0.1",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.2.1",
    "@angular-devkit/core": "18.2.1",
    "@angular-devkit/schematics": "18.2.1",
    "@angular-eslint/eslint-plugin": "18.0.1",
    "@angular-eslint/eslint-plugin-template": "18.0.1",
    "@angular-eslint/template-parser": "18.0.1",
    "@angular/cli": "~17.3.0",
    "@angular/compiler-cli": "18.2.1",
    "@angular/language-service": "18.2.1",
    "@cyclonedx/cyclonedx-npm": "1.19.3",
    "@nx/cypress": "19.6.2",
    "@nx/eslint": "19.6.2",
    "@nx/eslint-plugin": "19.6.2",
    "@nx/jest": "19.6.2",
    "@nx/js": "19.6.2",
    "@nx/web": "19.6.2",
    "@nx/workspace": "19.6.2",
    "@openapitools/openapi-generator-cli": "2.7.0",
    "@schematics/angular": "18.2.1",
    "@swc-node/register": "1.9.2",
    "@swc/core": "1.5.7",
    "@swc/helpers": "0.5.12",
    "@types/jest": "29.5.12",
    "@types/lodash-es": "^4.17.6",
    "@types/node": "18.16.9",
    "@types/uuid": "^9.0.4",
    "@typescript-eslint/eslint-plugin": "7.16.0",
    "@typescript-eslint/parser": "7.16.0",
    "@typescript-eslint/utils": "^7.16.0",
    "cypress": "13.13.0",
    "eslint": "~8.57.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-cypress": "^2.13.4",
    "he": "^1.2.0",
    "jest": "29.7.0",
    "jest-environment-jsdom": "29.7.0",
    "jest-environment-node": "^29.7.0",
    "jest-preset-angular": "14.1.1",
    "nx": "19.6.2",
    "prettier": "^2.6.2",
    "rimraf": "^5.0.10",
    "ts-jest": "29.2.5",
    "ts-node": "10.9.1",
    "typescript": "5.5.4"
  },
  "volta": {
    "node": "18.20.4"
  },
  "overrides": {
    "filelist": "1.0.4",
    "jake": "10.9.1",
    "ejs": "3.1.10"
  }
}
